import type { SVGProps } from 'react';
const SvgYandex = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
    <path fill="#FC3F1D" d="M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18" />
    <path
      fill="#fff"
      d="M10.29 14.5H12.2V3.52h-2.78c-2.797 0-4.266 1.437-4.266 3.554 0 1.69.806 2.686 2.243 3.713l-2.496 3.712h2.07l2.78-4.155-.963-.648C7.619 8.906 7.05 8.29 7.05 6.963c0-1.169.821-1.959 2.386-1.959h.852z"
    />
  </svg>
);
export default SvgYandex;
